var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Left-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M0.198455 0.214954C0.438774 -0.0355297 0.815005 -0.0585153 1.08023 0.146147L1.15622 0.214375L7.00106 6.29318L12.8403 0.20731C13.0806 -0.0431743 13.4568 -0.0661599 13.722 0.138502L13.798 0.206731C14.0386 0.456924 14.0606 0.84865 13.864 1.12482L13.7985 1.20394L7.48064 7.78903C7.24032 8.03951 6.86409 8.0625 6.59887 7.85784L6.52288 7.78961L0.198917 1.21217C-0.0656892 0.936954 -0.0658962 0.490487 0.198455 0.214954Z",
    fill: "#4C4C4C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/ArrowDown_Black.f961d17f76f3f924c91a8ea0aab6c179.svg";
export { ForwardRef as ReactComponent };